import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ProgressSpinnerLoaderComponent } from './progress-spinner-loader.component';

@NgModule({
  imports: [CommonModule, MatProgressBarModule, MatProgressSpinnerModule],
  declarations: [ProgressSpinnerLoaderComponent],
  exports: [MatProgressBarModule, ProgressSpinnerLoaderComponent]
})
export class TiimeLoaderModule {}
